import React from 'react'
import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"


export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2 className= 'animation' data-aos="fade-down">Skills</h2>
                        <p className= 'animation' data-aos="fade-down" data-aos-delay="100">These are some of the skills I've gained over the years, <br />a powerful toolkit at my disposal and ready to help you achieve your goals.</p>
                        <div className= 'animation' data-aos="fade-up" data-aos-delay="300">
                          <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                              <div className="item">
                                  <img src={meter3} alt="Image" />
                                  <h5>UI/UX Design</h5>
                              </div>
                              <div className="item">
                                  <img src={meter1} alt="Image" />
                                  <h5>Figma</h5>
                              </div>
                              <div className="item">
                                  <img src={meter2} alt="Image" />
                                  <h5>Graphic Design</h5>
                              </div>
                              <div className="item">
                                  <img src={meter1} alt="Image" />
                                  <h5>Animation</h5>
                              </div>
                              <div className="item">
                                  <img src={meter2} alt="Image" />
                                  <h5>Coding Experience</h5>
                              </div>
                              <div className="item">
                                  <img src={meter3} alt="Image" />
                                  <h5>Adobe Creative Suite</h5>
                              </div>
                              <div className="item">
                                  <img src={meter3} alt="Image" />
                                  <h5>Mockups</h5>
                              </div>
                              <div className="item">
                                  <img src={meter1} alt="Image" />
                                  <h5>Logo Design</h5>
                              </div>
                          </Carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}